import React, { useEffect, useState, useRef } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
export default function Footer() {
    const [contactos, setContactos] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [activePolicy, setActivePolicy] = useState(null);
    useEffect(() => {
        cargarPolicies();

    }, []);

    useEffect(() => {
        cargarContacto();

    }, []);



    const cargarPolicies = () => {
        fetch(`${baseURL}/policiesGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setPolicies(data.policies || []))
            .catch(error => console.error('Error al cargar políticas:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };


    return (
        <>
        <div className='FooterContain'>
            <div className='footerText'>
                <Anchor to='' target="_blank">   <img src={logo} alt="logo" /></Anchor>
                <h2>
                    {contactos.nombre}
                </h2>
                <div className='socials'>
                    <Anchor to={contactos.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                    <Anchor to={`https://wa.me/${String(contactos.telefono || '').replace(/\D/g,'')}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                    <Anchor to={contactos.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>

                </div>
            </div>
            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                <Anchor to={`https://wa.me/${String(contactos.telefono || '').replace(/\D/g,'')}`} target="_blank">{contactos.telefono}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>

            </div>
            <div className='footerText'>
                <h3>Legal</h3>
                {policies.map((policy) => (
                    <button key={policy.policyKey} className='policyFooterBtn' type='button' onClick={() => setActivePolicy(policy)}>
                        {policy.title}
                    </button>
                ))}
            </div>
            {activePolicy && (
                <div className='policyModalOverlay' onClick={() => setActivePolicy(null)}>
                    <div className='policyModal' onClick={(e) => e.stopPropagation()}>
                        <button className='policyClose' onClick={() => setActivePolicy(null)}>×</button>
                        <h2>{activePolicy.title}</h2>
                        <p>{activePolicy.content}</p>
                    </div>
                </div>
            )}
        </div>
        <div className='footerCopyright'>
            © 2026 Mercado KY-13. Powered by <a href='https://wa.me/5358410381' target='_blank' rel='noreferrer'>Hiran &lt;/scorpion&gt;</a>
        </div>
        </>
    )
}
